import { render } from "./RollbackModal.vue?vue&type=template&id=7a8432cd"
import script from "./RollbackModal.vue?vue&type=script&lang=js"
export * from "./RollbackModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__